<ng-template #modalAjoutSolde let-modal>
  <div class="modal-content ajout-solde-modal">
    <div class="modal-header border-0 pb-0" style="background-color: transparent">
      <button
        type="button"
        class="close"
        aria-label="Fermer"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body " style="padding: 41px 64px 64px">
      <h1 class="text-center mb-2 ajout-solde-title">Ajouter une caisse</h1>
      <div class="form-group">
        <label>Nom de caisse <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="formData.type_solde_input"
          name="type_solde_input"
          autocomplete="off"
        />
      </div>

      <div class="form-group mb-0">
        <label>Montant initial du solde <span class="text-danger">*</span></label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="formData.montant_total"
          name="montant_total"
          min="0"
          step="0.001"

        />
      </div>
        <div class="d-flex justify-content-center align-items-center" style="gap: 12px;margin-top: 12px">
            <button type="button" class="btn btn-primary" (click)="enregistrer()" [disabled]="isLoading">
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1" role="status"></span>
                Enregistrer
            </button>
            <button type="button" class="btn" (click)="modal.dismiss('cancel')" [disabled]="isLoading" style="background-color: rgba(128, 131, 144, 0.16);color: rgba(128, 131, 144, 1)">
                Annuler
            </button>

        </div>
    </div>

  </div>
</ng-template>
